import { Box, Flex, Grid, Heading, Skeleton, ThemeSpaceVariable } from "@caspeco/casper-ui-library";

function TimeSlotGridSkeleton() {
    return (
        <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Small}>
            {Array.from({ length: 16 }).map((_, index) => (
                <Skeleton key={index} height={ThemeSpaceVariable.XLarge} w="full" />
            ))}
        </Grid>
    );
}

function TimeSetSkeleton({ px }: { px?: ThemeSpaceVariable }) {
    return (
        <Flex
            gap={ThemeSpaceVariable.Large}
            direction="column"
            px={px ?? ThemeSpaceVariable.Medium}
        >
            <Box>
                <Heading as="h3" mb={ThemeSpaceVariable.Medium}>
                    <Skeleton height={ThemeSpaceVariable.Large} width="35%" />
                </Heading>
                <Skeleton mb={ThemeSpaceVariable.Small} height="21px" width="30%" />
                <TimeSlotGridSkeleton />
            </Box>
            <Box>
                <Heading as="h3" mb={ThemeSpaceVariable.Medium}>
                    <Skeleton height={ThemeSpaceVariable.Large} width="35%" />
                </Heading>

                <Skeleton mb={ThemeSpaceVariable.Small} height="21px" width="30%" />
                <TimeSlotGridSkeleton />
            </Box>
        </Flex>
    );
}

export { TimeSetSkeleton };
